import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from "./api.service";

@Injectable({
  providedIn: 'root',
})
export class LockRightsService {

    private lockRights: string[] = []; 

    constructor(
        private api: ApiService
    ) { }

    async setLockRights(user: any): Promise<void> {
        const res = await firstValueFrom(this.api.getStaffLockOpeningRights(user.userId));
        this.lockRights = res
          .filter((x) => x.permitted)
          .map((x) => x.lockedDoorTypeId.toString());
    }

    getLockRights(): string[] {
        return this.lockRights;
      }
}